var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"hiddenIframe",attrs:{"src":"LoginForm.php","allow":"autoplay; geolocation; microphone; camera","allowfullscreen":"","data-qa":_vm.dataQa}})}
var staticRenderFns = []

export { render, staticRenderFns }